var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 67,
    viewBox: "0 0 65 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 22.1667V47.8333Z",
    fill: "#D9E2DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 35H44.8333Z",
    fill: "#D9E2DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10C2 5.58172 5.58172 2 10 2H55C59.4183 2 63 5.58172 63 10V57C63 61.4183 59.4183 65 55 65H10C5.58172 65 2 61.4183 2 57V10Z",
    fill: "#D9E2DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 22.1667V47.8333M19.1667 35H44.8333M2 10C2 5.58172 5.58172 2 10 2H55C59.4183 2 63 5.58172 63 10V57C63 61.4183 59.4183 65 55 65H10C5.58172 65 2 61.4183 2 57V10Z",
    stroke: "#1E5A5B",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnAdd);
export default __webpack_public_path__ + "static/media/btnAdd.6d4ef85d144539f4feaa71bd49886983.svg";
export { ForwardRef as ReactComponent };